export default "__VITE_ASSET__B8CiVvWs__"